import axios from "axios";
import { L } from "@/i18n";

export const TOKEN_KEY = "l4c_admin_token";
export const USER_KEY = "l4c_admin_user";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_L4C_API_URL}/api`,
  timeout: 30000,
});

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const isLogin = error.config?.url?.includes("/auth/login");
    if (error.response?.status === 401 && !isLogin) {
      clearSession();
      if (window.location.pathname !== "/login") window.location.assign("/login");
    }
    return Promise.reject(error);
  },
);

export const errorMessage = (error, fallback = L("An unexpected error occurred.", "Ocorreu um erro inesperado.")) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (!error?.response) return L("Unable to reach the API. Check your connection.", "Sem ligação à API. Verifique a sua ligação.");
  return error?.message || fallback;
};
